import type { IconProps } from './types';

function BeakerIcon(props: IconProps) {
  const { size = 24, color = 'currentColor', ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M5.90693 14.8114H18.0933M5.4375 2.625H18.5625M8.25 2.625V10.125L2.625 21.375H21.375L15.75 10.125V2.625H8.25Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
}

export { BeakerIcon };
